import { NotificationMessage } from '@gravitate-js/excalibrr'

export const handleUploadResponse = async (
  resp,
  setIsUploading,
  setStatusResponse,
  setUploadStatusModalVisible,
  normalizeFunction
) => {
  let statusData = resp
  if (resp.data) statusData = resp.data
  if (normalizeFunction) {
    statusData = normalizeFunction(statusData)
  }
  // CONDITIONS
  // Server Error (removed the .catch, wasn't catching, need try catch block in handleUpload?)
  // IF WE UPDATED RECORDS
  // IF WE DIDN'T UPDATE RECORDS AND THERE ARE ERRORS
  // IF WE DON'T GET A 200
  // IF WE DO GET A 200 AND NO ERRORS AND NO WARNINGS

  // DYNAMIC PROPERITES (WHAT CHANGES)
  // sometimes we update the status Response
  // Message string changes
  // status (error or success) boolean for the notification
  // should we show the modal?
  if (statusData.updated_count > 0) {
    setStatusResponse(statusData)
    NotificationMessage(`Upload Successful`, `Your file has been successfully uploaded.`, false)
  } else if (statusData.updated_count === 0 && statusData.error_count > 0) {
    setStatusResponse(statusData)
    NotificationMessage(`Upload Error`, `Check to be sure all fields completed correctly.`, true)
  } else if (statusData.result !== 'success') {
    NotificationMessage(
      `Upload Error`,
      `There was a problem uploading your file, make sure your file ends with ".xlsx".`,
      true
    )
  } else if (statusData.error_count === 0 && statusData.warning_count === 0 && statusData.result === 'success') {
    NotificationMessage(`No Fields Updated`, `Uploaded data is the same as existing data.`, false)
    setIsUploading(false)
    setUploadStatusModalVisible(false)
    return null
  }
  setStatusResponse(statusData)
  setIsUploading(false)
  setUploadStatusModalVisible(true)
}

export const normalizeLoaderResponse = (response, accessor) => {
  const data = response[accessor]
  const normalizedObject = {
    result: data.successful_count > 0 ? responseStatuses.SUCCESS : responseStatuses.ERROR,
    message: `You uploaded a sheet with ${data.row_count} rows, here are the results.`,
    error_count: data.error_count,
    warning_count: 0,
    updated_count: data.successful_count,
  }
  const rowErrors = []
  Object.keys(data.row_errors).forEach((key) => {
    data.row_errors[key].forEach((message) => {
      rowErrors.push({ row_number: key, message: JSON.stringify(message) })
    })
    normalizedObject.errors = rowErrors
    normalizedObject.warnings = []
  })
  return normalizedObject
}

export const responseStatuses = {
  SUCCESS: 'success',
  PARTIAL_SUCCESS: 'partial success',
  ERROR: 'error',
}
